import { IonIcon } from '@ionic/react';
import React, { useState } from 'react';
import { NavLink, useHistory, useLocation } from 'react-router-dom';
import { FOOTER_MOBILE_ITEM } from '../../../constants/FooterView';
import HomeImgCancel from '../../../assets/images/footer/homecross.svg';
import './MobileFooter.scss';
import Click from '../../../assets/images/footer/theme.svg';
import Star from '../../../assets/images/footer/favrate.svg';
import MyBetsImg from '../../../assets/images/common/bets.svg';
import NotificationIcon from '../../../assets/images/footer/Notifications.svg';
import footermenu from '../../../assets/images/footer/footermenu.svg';
import MiniGameBtn from "../../../assets/images/casino/mini_games_btn.png";
import MiniGameGif from "../../../assets/images/casino/mini_games_gif.gif";
import { RootState } from '../../../models/RootState';
import { connect } from 'react-redux';

type StoreProps = {
  loggedIn: boolean;
  isMolobby: boolean;
};

const MobileFooter: React.FC<StoreProps> = (props) => {
  const { loggedIn, isMolobby } = props;
  const { pathname } = useLocation();
  const [showAdditionalIcons, setShowAdditionalIcons] = useState<boolean>(false);
  const history = useHistory();

  const mlobbyBtnClick = async (
  ) => {
    if (loggedIn) {
      document.getElementsByClassName('mlobby-main-dc')[0].classList.remove('d-none');
      document.getElementsByClassName('mini-casino-btn')[0].classList.add('d-none')

      if (!isMolobby) {
        sessionStorage.setItem('mlobby', 'true');
      }

    } else {
      history.push('/login');
    }
  };
  
  return (
    <>
      {showAdditionalIcons && (
        <div className="circle-big mob-view">
          <NavLink to="/my-notification">
            <div
              className="circle one"
              onClick={() => setShowAdditionalIcons((prev) => !prev)}
            >
              <IonIcon src={NotificationIcon} className="icon" />
            </div>{' '}
          </NavLink>

          <NavLink to="/mo/oneclick">
            <div
              className="circle two"
              onClick={() => setShowAdditionalIcons((prev) => !prev)}
            >
              <IonIcon src={Click} className="icon" />
            </div>
          </NavLink>
          <NavLink to="/favorite">
            <div
              className="circle three"
              onClick={() => setShowAdditionalIcons((prev) => !prev)}
            >
              <IonIcon src={Star} className="icon" />
            </div>{' '}
          </NavLink>
          <NavLink to="/my_bets">
            <div
              className="circle four"
              onClick={() => setShowAdditionalIcons((prev) => !prev)}
            >
              <IonIcon src={MyBetsImg} className="icon" />
            </div>
          </NavLink>
        </div>
      )}
      <div className="exch-mob-header-ctn mob-view">
        <a className="exch-mob-nav-link mlobby-main mini-casino-btn" onClick={() => mlobbyBtnClick()}>
          {/* <div className="exch-nav-item-ctn ">
            <img src={CasinoImg} />
          </div> */}
          <div className="exch-nav-item-ctn">
            <img className="mini-game-btn-bg" src={MiniGameBtn} />
            <img src={MiniGameGif} className="mini-games-gif" />
          </div>
        </a>
        {FOOTER_MOBILE_ITEM.map((item, idx) => {
          return (
            <>
              {item?.slug !== '/home' ? (
                <NavLink
                  to={item.slug}
                  className="exch-mob-nav-link"
                  key={item.slug + item.lable}
                  exact={pathname === '/exchange_sports/inplay'}
                >
                  <div className="exch-nav-item-ctn">
                    <IonIcon
                      src={item.footerIcon}
                      key={item.slug + idx}
                      className="exch-nav-item-icon"
                    />

                    <div className="exch-nav-item-label">{item.lable}</div>
                  </div>
                </NavLink>
              ) : (
                <div key={item.slug + item.lable} className="home-menu">
                  <div className='menu-bg'>
                    <IonIcon
                      src={!showAdditionalIcons ? footermenu : HomeImgCancel}
                      key={item.slug + idx}
                      className="menu-item-icon"
                      onClick={() => setShowAdditionalIcons((prev) => !prev)}
                    />
                  </div>
                </div>
              )}
            </>
          );
        })}
      </div>
    </>
  );
};
const mapStateToProps = (state: RootState) => {
  return {
    loggedIn: state.auth.loggedIn,
    isMolobby: state.auth.isMolobby
  };
};

export default connect(mapStateToProps, null)(MobileFooter);
